export default __webpack_public_path__ + "0da692d184a28c297fcf214dabcc7549.png";